<div class = "flex h-3/4 align-center items-center justify-center">
<img class = "md:w-6/12 w-full" src="../../../assets/img/redirect.png" alt="">
</div>
<a id = "download" #download href="{{url}}" class="d-none"></a>

<!-- <div>{{url}}</div> -->